module.exports = __webpack_public_path__ + "static/img/hfksdjhjkfa.68b2b362.png";